import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  id: "container"
};
const _hoisted_2 = {
  key: 0,
  style: {
    "width": "100%",
    "height": "100%",
    "text-align": "center",
    "margin-top": "10%"
  }
};
const _hoisted_3 = {
  key: 1
};
const _hoisted_4 = {
  style: {
    "height": "100vw",
    "width": "10vh",
    "top": "90vh"
  },
  id: "area-box"
};
const _hoisted_5 = {
  class: "menu-i",
  style: {
    "height": "25vw"
  }
};
const _hoisted_6 = ["src"];
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "menu-i",
  style: {
    "height": "25vw"
  }
};
const _hoisted_9 = ["src"];
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "menu-i",
  style: {
    "height": "25vw"
  }
};
const _hoisted_12 = ["src"];
const _hoisted_13 = ["src"];
const _hoisted_14 = ["src"];
const _hoisted_15 = ["src"];
const _hoisted_16 = ["src"];
const _hoisted_17 = ["src"];
const _hoisted_18 = ["src"];
const _hoisted_19 = ["src"];
const _hoisted_20 = ["src"];
const _hoisted_21 = ["src"];
const _hoisted_22 = {
  id: "dom-box-d"
};
const _hoisted_23 = {
  key: 0,
  style: {
    "width": "30vw",
    "height": "100vw"
  }
};
const _hoisted_24 = {
  key: 0,
  style: {
    "height": "95vw",
    "margin-top": "1vw",
    "background-color": "#f0f1eb",
    "background-size": "100% 100%",
    "border-radius": "10px",
    "padding": "1.3vw"
  }
};
const _hoisted_25 = {
  style: {
    "height": "90vw",
    "background-color": "#f0f1eb",
    "overflow-y": "scroll",
    "padding": "5px 5px 5vw"
  }
};
const _hoisted_26 = {
  style: {
    "font-weight": "600",
    "text-align": "center",
    "padding-bottom": "10px",
    "margin-top": "10px",
    "font-size": "1rem"
  }
};
const _hoisted_27 = {
  key: 0,
  style: {
    width: `100%`
  }
};
const _hoisted_28 = ["src"];
const _hoisted_29 = {
  style: {
    "font-size": "0.8rem",
    "color": "#333333",
    "margin-top": "15px",
    "padding-right": "10px",
    "text-indent": "1.6rem",
    "text-align": "justify",
    "letter-spacing": "0.05em"
  }
};
const _hoisted_30 = {
  style: {
    "font-size": "0.8rem",
    "color": "#333333",
    "margin-top": "10px"
  }
};
const _hoisted_31 = {
  style: {
    "width": "calc(100% - 13vw)",
    "display": "inline-block"
  }
};
const _hoisted_32 = {
  style: {
    "font-size": "0.8rem",
    "color": "#333333",
    "margin-top": "10px",
    "margin-bottom": "20px"
  }
};
const _hoisted_33 = {
  style: {
    "width": "calc(100% - 13vw)",
    "display": "inline-block",
    "word-break": "break-all"
  }
};
const _hoisted_34 = {
  key: 1,
  style: {
    "font-size": "0.8rem",
    "color": "#333333",
    "margin-top": "15px"
  }
};
const _hoisted_35 = {
  class: "recommend_content"
};
const _hoisted_36 = {
  style: {
    "color": "black"
  }
};
const _hoisted_37 = ["onClick"];
const _hoisted_38 = {
  key: 1,
  style: {
    "width": "100vh",
    "height": "100vw"
  }
};
const _hoisted_39 = {
  style: {
    "width": "70%",
    "margin": "0 auto"
  }
};
const _hoisted_40 = {
  style: {
    "padding": "10px",
    "width": "100%",
    "text-align": "center"
  }
};
const _hoisted_41 = ["src"];
const _hoisted_42 = {
  style: {
    "padding": "10px",
    "width": "100%",
    "text-align": "center"
  }
};
const _hoisted_43 = ["src"];
const _hoisted_44 = {
  style: {
    "padding": "10px",
    "width": "100%",
    "text-align": "center"
  }
};
const _hoisted_45 = ["src"];
const _hoisted_46 = {
  style: {
    "padding": "10px",
    "width": "100%",
    "text-align": "center"
  }
};
const _hoisted_47 = ["src"];
const _hoisted_48 = {
  key: 2,
  style: {
    "width": "100vh",
    "height": "100vw"
  }
};
const _hoisted_49 = {
  class: "line_menu",
  style: {}
};
const _hoisted_50 = ["onClick"];
const _hoisted_51 = {
  key: 3,
  style: {
    "width": "100vh",
    "height": "100vw"
  }
};
const _hoisted_52 = {
  style: {
    "width": "95vw"
  }
};
const _hoisted_53 = {
  class: "line_menu_grid"
};
const _hoisted_54 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_swiper_slide = _resolveComponent("swiper-slide");
  const _component_swiper = _resolveComponent("swiper");
  const _component_IconFont = _resolveComponent("IconFont");
  const _component_nut_popup = _resolveComponent("nut-popup");
  const _component_nut_col = _resolveComponent("nut-col");
  const _component_nut_row = _resolveComponent("nut-row");
  const _directive_horizontalscreen = _resolveDirective("horizontalscreen");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.landscape ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[29] || (_cache[29] = [_createElementVNode("h1", null, "请锁屏后横屏观看", -1)]))])) : !$data.landscape ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_cache[31] || (_cache[31] = _createElementVNode("div", {
    id: "box",
    style: {
      "width": "100vw",
      "height": "100vh"
    }
  }, null, -1)), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", null, [_withDirectives(_createElementVNode("div", _hoisted_5, [$data.type !== 1 ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: `/btn/gn.png?v=${$data.staticV}`,
    alt: "",
    width: "70%",
    onClick: _cache[0] || (_cache[0] = $event => $options.changeType(1))
  }, null, 8, _hoisted_6)) : (_openBlock(), _createElementBlock("img", {
    key: 1,
    src: `/gn.png?v=${$data.staticV}`,
    alt: "",
    width: "70%",
    onClick: _cache[1] || (_cache[1] = $event => $options.changeType(1))
  }, null, 8, _hoisted_7))], 512), [[_vShow, $data.type != 3]]), _withDirectives(_createElementVNode("div", _hoisted_8, [$data.type !== 2 ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: `/btn/gs.png?v=${$data.staticV}`,
    alt: "",
    width: "70%",
    onClick: _cache[2] || (_cache[2] = $event => $options.changeType(2))
  }, null, 8, _hoisted_9)) : (_openBlock(), _createElementBlock("img", {
    key: 1,
    src: `/gs.png?v=${$data.staticV}`,
    alt: "",
    width: "70%",
    onClick: _cache[3] || (_cache[3] = $event => $options.changeType(2))
  }, null, 8, _hoisted_10))], 512), [[_vShow, $data.type != 3]]), _withDirectives(_createElementVNode("div", _hoisted_11, [$data.type !== 4 ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: `/btn/gd.png?v=${$data.staticV}`,
    alt: "",
    width: "70%",
    onClick: _cache[4] || (_cache[4] = $event => $options.changeType(4))
  }, null, 8, _hoisted_12)) : (_openBlock(), _createElementBlock("img", {
    key: 1,
    src: `/gd.png?v=${$data.staticV}`,
    alt: "",
    width: "70%",
    onClick: _cache[5] || (_cache[5] = $event => $options.changeType(4))
  }, null, 8, _hoisted_13))], 512), [[_vShow, $data.type != 3]]), _createElementVNode("div", {
    class: "menu-i",
    style: {
      "height": "25vw"
    },
    onClick: _cache[6] || (_cache[6] = $event => $options.changeType(3))
  }, [$data.type !== 3 ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: `/btn/xl.png?v=${$data.staticV}`,
    alt: "",
    width: "70%"
  }, null, 8, _hoisted_14)) : (_openBlock(), _createElementBlock("img", {
    key: 1,
    src: `/xl.png?v=${$data.staticV}`,
    alt: "",
    width: "70%"
  }, null, 8, _hoisted_15))]), _withDirectives(_createElementVNode("div", null, [_withDirectives(_createElementVNode("div", null, [_createElementVNode("img", {
    src: `/menu/gsgn.png?v=${$data.staticV}`,
    onClick: _cache[7] || (_cache[7] = $event => $data.sub_type = 1),
    class: "line_menu_btn",
    style: {
      "margin": "10px 0px 20vw"
    }
  }, null, 8, _hoisted_16), _createElementVNode("img", {
    src: `/menu/gudao.png?v=${$data.staticV}`,
    onClick: _cache[8] || (_cache[8] = $event => $options.openGdLineMenu()),
    class: "line_menu_btn"
  }, null, 8, _hoisted_17)], 512), [[_vShow, $data.sub_type == 0]]), _withDirectives(_createElementVNode("div", null, [_createElementVNode("img", {
    src: `/menu/guanniao.png?v=${$data.staticV}`,
    onClick: _cache[9] || (_cache[9] = $event => $options.openLineMenu(0)),
    class: "line_menu_btn",
    style: {
      "margin": "10px 0px 20px"
    }
  }, null, 8, _hoisted_18), _createElementVNode("img", {
    src: `/menu/sheying.png?v=${$data.staticV}`,
    onClick: _cache[10] || (_cache[10] = $event => $options.openLineMenu(1)),
    class: "line_menu_btn",
    style: {
      "margin-bottom": "20px"
    }
  }, null, 8, _hoisted_19), _createElementVNode("img", {
    src: `/menu/yanxue.png?v=${$data.staticV}`,
    onClick: _cache[11] || (_cache[11] = $event => $options.openLineMenu(2)),
    class: "line_menu_btn",
    style: {
      "margin-bottom": "20px"
    }
  }, null, 8, _hoisted_20), _createElementVNode("img", {
    src: `/menu/zijia.png?v=${$data.staticV}`,
    onClick: _cache[12] || (_cache[12] = $event => $options.openLineMenu(3)),
    class: "line_menu_btn",
    style: {
      "margin-bottom": "20px"
    }
  }, null, 8, _hoisted_21)], 512), [[_vShow, $data.sub_type == 1]])], 512), [[_vShow, $data.type == 3]])])])), [[_directive_horizontalscreen]]), _createElementVNode("div", _hoisted_22, [$data.showMarker ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_23, [_createVNode(_component_nut_popup, {
    position: "left",
    closeable: true,
    onClickOverlay: _cache[15] || (_cache[15] = $event => $data.showMarker = false),
    onClickCloseIcon: _cache[16] || (_cache[16] = $event => $data.showMarker = false),
    overlay: false,
    "pop-class": "w-pop",
    visible: $data.showMarker,
    "onUpdate:visible": _cache[17] || (_cache[17] = $event => $data.showMarker = $event)
  }, {
    default: _withCtx(() => [$data.showMarker ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, _toDisplayString($data.markerDetail.name), 1), $data.markerDetail.imgData.length >= 1 ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createVNode(_component_swiper, {
      class: "mySwiper",
      autoplay: {
        delay: 2500,
        disableOnInteraction: false
      },
      pagination: {
        clickable: true
      },
      modules: $data.modules
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.markerDetail.imgData, img => {
        return _openBlock(), _createBlock(_component_swiper_slide, {
          key: img.src
        }, {
          default: _withCtx(() => [_createElementVNode("img", {
            src: `${img.src}`,
            alt: "",
            style: {
              "height": "34vw"
            }
          }, null, 8, _hoisted_28)]),
          _: 2
        }, 1024);
      }), 128))]),
      _: 1
    }, 8, ["modules"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_29, _toDisplayString($data.markerDetail.desc), 1), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_createVNode(_component_IconFont, {
      width: "0.8rem",
      height: "auto",
      name: `https://gsgn.linkingtrip.cn/dz_icon.png?v=1`,
      style: {
        "position": "relative",
        "top": "1px"
      }
    }), _createTextVNode(" " + _toDisplayString($data.markerDetail.address), 1)]), _createElementVNode("img", {
      src: "/dh.png",
      alt: "",
      style: {
        "float": "right",
        "width": "13vw"
      },
      onClick: _cache[13] || (_cache[13] = $event => $options.openAd($data.markerDetail))
    })]), _withDirectives(_createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createVNode(_component_IconFont, {
      width: "0.8rem",
      height: "auto",
      name: `https://gsgn.linkingtrip.cn/ms_icon.png?v=1`,
      style: {
        "position": "relative",
        "top": "1px"
      }
    }), _createTextVNode(" " + _toDisplayString($data.markerDetail.tel), 1)]), _createElementVNode("img", {
      src: "/tel.png",
      style: {
        "float": "right",
        "width": "13vw"
      },
      onClick: _cache[14] || (_cache[14] = $event => $options.callPhone($data.markerDetail.tel))
    })], 512), [[_vShow, $data.markerDetail.tel]]), $data.markerDetail.hasOwnProperty('recommend') ? (_openBlock(), _createElementBlock("div", _hoisted_34, [_cache[30] || (_cache[30] = _createElementVNode("div", {
      style: {
        "font-size": "0.9rem",
        "color": "#0d0d0d"
      }
    }, "周边餐饮/住宿推荐：", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.markerDetail.recommend, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        style: {
          "display": "flex",
          "align-items": "center",
          "margin-top": "10px"
        },
        key: index
      }, [_createElementVNode("div", _hoisted_35, [_createElementVNode("span", _hoisted_36, _toDisplayString(item.name), 1), _createElementVNode("span", null, _toDisplayString(item.tel), 1), _createElementVNode("span", null, _toDisplayString(item.address), 1)]), _createElementVNode("div", null, [_createElementVNode("img", {
        src: "/tel.png",
        style: {
          "float": "right",
          "width": "13vw"
        },
        onClick: $event => $options.callPhone(item.tel)
      }, null, 8, _hoisted_37)])]);
    }), 128))])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["visible"])])), [[_directive_horizontalscreen]]) : _createCommentVNode("", true), $data.dvisible ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_38, [_createVNode(_component_nut_popup, {
    visible: $data.dvisible,
    "onUpdate:visible": _cache[22] || (_cache[22] = $event => $data.dvisible = $event),
    style: {
      "background-color": "transparent",
      "background": "url('/xbg.jpg?v=1.2')",
      "width": "100%",
      "display": "flex",
      "flex-direction": "row",
      "align-items": "center",
      "height": "100%",
      "background-size": "100% 100%"
    }
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_39, [_createVNode(_component_nut_row, null, {
      default: _withCtx(() => [_createVNode(_component_nut_col, {
        span: 6
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_40, [_createElementVNode("img", {
          src: `/btn/gn.png?v=${$data.staticV}`,
          style: {
            "width": "20vw"
          },
          onClick: _cache[18] || (_cache[18] = $event => $options.changeType(1))
        }, null, 8, _hoisted_41)])]),
        _: 1
      }), _createVNode(_component_nut_col, {
        span: 6
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_42, [_createElementVNode("img", {
          src: `/btn/gs.png?v=${$data.staticV}`,
          style: {
            "width": "20vw"
          },
          onClick: _cache[19] || (_cache[19] = $event => $options.changeType(2))
        }, null, 8, _hoisted_43)])]),
        _: 1
      }), _createVNode(_component_nut_col, {
        span: 6
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_44, [_createElementVNode("img", {
          src: `/btn/gd.png?v=${$data.staticV}`,
          style: {
            "width": "20vw"
          },
          onClick: _cache[20] || (_cache[20] = $event => $options.changeType(4))
        }, null, 8, _hoisted_45)])]),
        _: 1
      }), _createVNode(_component_nut_col, {
        span: 6
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_46, [_createElementVNode("img", {
          src: `/btn/xl.png?v=${$data.staticV}`,
          style: {
            "width": "20vw"
          },
          onClick: _cache[21] || (_cache[21] = $event => $options.changeType(3))
        }, null, 8, _hoisted_47)])]),
        _: 1
      })]),
      _: 1
    })])]),
    _: 1
  }, 8, ["visible"])])), [[_directive_horizontalscreen]]) : _createCommentVNode("", true), $data.showLineMenu ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_48, [_createVNode(_component_nut_popup, {
    "pop-class": "line_menu_pop",
    style: {
      "height": "55vw",
      "overflow-y": "scroll",
      "padding": "30px 30px",
      "background": "url('/line_menu_bg.png')",
      "background-size": "100% 100%"
    },
    closeable: "",
    round: "",
    visible: $data.showLineMenu,
    "onUpdate:visible": _cache[23] || (_cache[23] = $event => $data.showLineMenu = $event),
    onClickOverlay: _cache[24] || (_cache[24] = $event => $data.showLineMenu = false),
    onClickCloseIcon: _cache[25] || (_cache[25] = $event => $data.showLineMenu = false)
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_49, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.lineMenu, (name, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: "line_name",
        style: {
          "margin-bottom": "10px"
        },
        onClick: $event => $options.polyline(name),
        key: index
      }, [_createElementVNode("span", null, _toDisplayString(name), 1)], 8, _hoisted_50);
    }), 128))])]),
    _: 1
  }, 8, ["visible"])])), [[_directive_horizontalscreen]]) : _createCommentVNode("", true), $data.showGdLineMenu ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_51, [_createVNode(_component_nut_popup, {
    "pop-class": "line_menu_pop",
    style: {
      "height": "72vw",
      "overflow-y": "scroll",
      "padding": "10px 30px",
      "display": "flex",
      "align-items": "center",
      "background": "url('/gd_line_menu_bg.png')",
      "background-size": "100% 100%"
    },
    closeable: "",
    round: "",
    visible: $data.showGdLineMenu,
    "onUpdate:visible": _cache[26] || (_cache[26] = $event => $data.showGdLineMenu = $event),
    onClickOverlay: _cache[27] || (_cache[27] = $event => $data.showGdLineMenu = false),
    onClickCloseIcon: _cache[28] || (_cache[28] = $event => $data.showGdLineMenu = false)
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_52, [_createElementVNode("div", _hoisted_53, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.lineMenu, (name, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: "line_name",
        style: {
          "width": "fit-content",
          "padding": "3px 16px 3px"
        },
        onClick: $event => $options.polyline(name),
        key: index
      }, [_createElementVNode("span", null, _toDisplayString(name), 1)], 8, _hoisted_54);
    }), 128))])])]),
    _: 1
  }, 8, ["visible"])])), [[_directive_horizontalscreen]]) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)]);
}